<template>
  <div id="app">
    <router-view></router-view>
    <v-bottom-sheet v-model="prompt">
      <v-sheet class="text-center" height="150px">
        <v-btn class="mt-6" text color="red" @click="update">
          Update
        </v-btn>
        <div class="py-3">
          A new version is found. Refresh to load it!
        </div>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>
<script>
export default {
  name: "App",

  components: {},

  created() {
    if (this.$workbox) {
      this.$workbox.addEventListener("waiting", () => {
        this.prompt = true;
      });
    }
  },
  data() {
    return {
      prompt: false
    };
  },

  methods: {
    async accept() {
      this.showUpgradeUI = false;
      await this.$workbox.messageSW({ type: "SKIP_WAITING" });
    },
    async update() {
      this.prompt = false;
      await this.$workbox.messageSW({ type: "SKIP_WAITING" });
    }
  }
};
</script>
<style>
@font-face {
  font-family: "Roboto";
  src: local("Roboto"), url(./assets/font/Roboto-Regular.ttf) format("truetype");
}
</style>
